import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

/**
 * The learner's own way in, set by the grown-up who looks after them.
 *
 * A child usually has no Google account, so before this their only routes were
 * the shared family password — one session for the whole household — or being
 * handed an unlocked device. An address and a password give them their own
 * account: their name, their progress, the kid shell.
 *
 * The same address is what Google sign-in matches on, so a learner who does have
 * a Google account lands in this profile rather than being refused or
 * duplicated. That is why the address is worth setting even with no password.
 *
 * Both fields are optional and stay optional: a learner who only ever practises
 * on the family device needs neither.
 *
 * The fields only — no border, no legend, no "neprivaloma" line. They sit on
 * the form's „Prisijungimas" tab, which names the group and carries that
 * sentence; keeping a copy here drew a box inside a box and said it twice.
 */
export function StudentLoginFields({
  disabled,
  defaultEmail,
  hasPassword,
}: {
  disabled?: boolean;
  defaultEmail?: string | null;
  /** Editing an account that already has one — changes the password field's job. */
  hasPassword?: boolean;
}) {
  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <div className="space-y-2">
        <Label htmlFor="email">El. paštas</Label>
        <Input
          id="email"
          name="email"
          type="email"
          autoComplete="off"
          placeholder="vardas@pastas.lt"
          defaultValue={defaultEmail ?? ""}
          disabled={disabled}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="password">Slaptažodis</Label>
        <Input
          id="password"
          name="password"
          type="password"
          // Off, not "new-password": the browser would otherwise offer to save
          // this under the *grown-up's* login, and it is the child's.
          autoComplete="off"
          placeholder={hasPassword ? "Nekeisite — palikite tuščią" : "Bent 8 simboliai"}
          minLength={8}
          disabled={disabled}
        />
        <p className="text-xs text-muted-foreground">
          {hasPassword
            ? "Įrašius naują — pakeisite. Palikus tuščią — liks senas."
            : "Bent 8 simboliai. Vėliau galėsite pakeisti."}
        </p>
      </div>
    </div>
  );
}
